import React, { PropTypes } from 'react'
import AuthorizationContainer from 'containers/AuthorizationContainer'

const MainNav = () => (
  <div className="nav">
    <AuthorizationContainer/>
  </div>
)

MainNav.propTypes = {
  logged: PropTypes.string,
}
export default MainNav



// WEBPACK FOOTER //
// ./src/components/MainNav.jsx